import WorkCycleScreen from './WorkCycleScreen.js';

export default WorkCycleScreen;
